import React from "react";
import { IImages } from "./imageGalleryImages";

type TImageGalleryThumbnailsSize = "inline" | "lightbox";

interface IImageGalleryThumbnails {
    images: Array<IImages>;
    currentImageIndex: number;
    size: TImageGalleryThumbnailsSize;
    onSelectImage: (index: number) => void;
}

export class ImageGalleryThumbnails extends React.Component<React.PropsWithChildren<IImageGalleryThumbnails>> {
    private stripRef = React.createRef<HTMLDivElement>();

    public componentDidMount(): void {
        this.centreActiveThumbnail("auto");
    }

    public componentDidUpdate(previousProps: IImageGalleryThumbnails): void {
        if (previousProps.currentImageIndex !== this.props.currentImageIndex) {
            this.centreActiveThumbnail("smooth");
        }
    }

    public render (): JSX.Element {
        return (
            <div
                className={`imageGalleryThumbs imageGalleryThumbs--${this.props.size}`}
                ref={this.stripRef}
                role="group"
                aria-label="Choose a photo"
            >
                {this.props.images.map((image, index) => (
                    <button
                        type="button"
                        key={index}
                        className={
                            "imageGalleryThumbs__thumb" +
                            (index === this.props.currentImageIndex ? " imageGalleryThumbs__thumb--selected" : "")
                        }
                        aria-label={`Photo ${index + 1} of ${this.props.images.length}`}
                        aria-current={index === this.props.currentImageIndex ? "true" : undefined}
                        onClick={() => this.props.onSelectImage(index)}
                    >
                        {/* The button already carries the label, so an alt here would make
                            a screen reader read every thumbnail twice. */}
                        <img src={image.src} alt="" loading="lazy" decoding="async" draggable={false} />
                    </button>
                ))}
            </div>
        );
    }

    private centreActiveThumbnail = (behavior: ScrollBehavior): void => {
        const strip = this.stripRef.current;

        if (strip === null) {
            return;
        }

        const thumbnail = strip.children[this.props.currentImageIndex];

        if (!(thumbnail instanceof HTMLElement)) {
            return;
        }

        const left = thumbnail.offsetLeft - ((strip.clientWidth - thumbnail.clientWidth) / 2);

        if (typeof strip.scrollTo === "function") {
            strip.scrollTo({ left, behavior });
            return;
        }

        strip.scrollLeft = left;
    };
}
